/**
 * Loader for the self-hosted HEIC decoder.
 *
 * heic-to (which embeds libheif) is LGPL-3.0, so it is deliberately NOT
 * bundled: scripts/ensure-heic-decoder.mjs copies its CSP-safe ESM build to
 * public/vendor/heic-to.js (+ license text) and we import it by URL at
 * runtime — a separate, user-replaceable file, the dynamic-linking analog
 * LGPL expects. The ignore comments keep webpack/Turbopack from inlining it
 * back into a chunk. The /csp build is also mandatory for another reason:
 * the default entry needs 'unsafe-eval', which the production CSP lacks.
 */

const HEIC_DECODER_URL = '/vendor/heic-to.js'

export type HeicDecoderModule = typeof import('heic-to/csp')

export function loadHeicDecoder(): Promise<HeicDecoderModule> {
  return import(/* webpackIgnore: true */ /* turbopackIgnore: true */ HEIC_DECODER_URL)
}
